var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav__select hover--pointer",attrs:{"role":"menuitem","href":_vm.item.url}},[_vm._v(_vm._s(_vm.item.label))])}
var staticRenderFns = []

export { render, staticRenderFns }